<div style="min-height: 30vh;" class="update-group-dialog">
    <button class="close" mat-button (click)="onClickClose()">X</button>
    <h3 mat-dialog-title style="background-color: lightgray;">Update Polls.</h3>
    <mat-dialog-content>
        <div >
            <mat-form-field appearance="fill">
                <mat-label>Select group to Update poll.</mat-label>
                <mat-select [(ngModel)]="selectedOption" (selectionChange)="manualUpdate()">
                    <mat-option *ngFor="let item of allGroups" [value]="item" >
                      {{item.name | titlecase}}
                    </mat-option>
                  </mat-select>
            </mat-form-field>
        </div>
    </mat-dialog-content>
</div>
